import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useCallback } from 'react';

import { AdditionalInfo, StateResponse } from '../../api/api';
import { apiInstance, useGlobalState, useGlobalStateUpdate } from './../global-state';

export function useDoorCodeMutation() {
  const state = useGlobalState();
  const updateFn = useGlobalStateUpdate();

  const mutationFn = async (request: AdditionalInfo) => {
    const { data } = await apiInstance.v4.additionalInformationPatch(
      state.checkout_session_id,
      request
    );
    return data;
  };

  const mutation = useMutation<StateResponse, AxiosError, AdditionalInfo>({
    mutationFn,
    onMutate: async newAdditionalInfo => {
      updateFn({
        ...state,
        additional_info: newAdditionalInfo,
      });

      return { prevState: state };
    },
    // Virtually impossible to type context as anything else
    onError: (_, __, context: any) => {
      updateFn(context.prevState);
    },
    onSuccess: data => {
      updateFn(data!);
    },
  });

  const mutate = useCallback(
    (values: AdditionalInfo) => {
      return mutation.mutate(values);
    },
    [mutation]
  );

  return { mutate, error: mutation.error, reset: mutation.reset };
}
